import { styled } from "linaria/react";

export const LoginRegisterSectionSwitch = styled.p`
    text-align: center;
    font-size: 12px;
`;
